"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SorobanReactProvider = void 0;
const react_1 = __importStar(require("react"));
const SorobanClient = __importStar(require("soroban-client"));
const _1 = require("./");
function networkToActiveChain(networkDetails, chains) {
    var _a, _b;
    const supported = networkDetails && chains.find((c) => c.networkPassphrase === (networkDetails === null || networkDetails === void 0 ? void 0 : networkDetails.networkPassphrase));
    const activeChain = networkDetails && {
        id: (_a = supported === null || supported === void 0 ? void 0 : supported.id) !== null && _a !== void 0 ? _a : networkDetails.networkPassphrase,
        name: (_b = supported === null || supported === void 0 ? void 0 : supported.name) !== null && _b !== void 0 ? _b : networkDetails.network,
        networkPassphrase: networkDetails.networkPassphrase,
        iconBackground: supported === null || supported === void 0 ? void 0 : supported.iconBackground,
        iconUrl: supported === null || supported === void 0 ? void 0 : supported.iconUrl,
        unsupported: !supported,
    };
    return activeChain;
}
function SorobanReactProvider({ appName, autoconnect = false, chains, children, connectors, }) {
    const flatWallets = connectors.flatMap(w => w.connectors);
    const activeWallet = flatWallets.length == 1 ? flatWallets[0] : undefined;
    const isConnectedRef = (0, react_1.useRef)(false);
    const [mySorobanContext, setSorobanContext] = react_1.default.useState(Object.assign(Object.assign({}, _1.defaultSorobanContext), { appName,
        autoconnect,
        chains,
        connectors,
        activeWallet, activeChain: chains.length == 1 ? chains[0] : undefined, connect: () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            let networkDetails = yield ((_a = mySorobanContext.activeWallet) === null || _a === void 0 ? void 0 : _a.getNetworkDetails());
            let activeChain = networkToActiveChain(networkDetails, chains);
            let address = yield ((_b = mySorobanContext.activeWallet) === null || _b === void 0 ? void 0 : _b.getPublicKey());
            let server = networkDetails && new SorobanClient.Server(networkDetails.networkUrl, { allowHttp: networkDetails.networkUrl.startsWith("http://") });
            // Now we can track that the wallet is finally connected
            isConnectedRef.current = true;
            setSorobanContext((c) => (Object.assign(Object.assign({}, c), { activeChain,
                address,
                server })));
        }), disconnect: () => __awaiter(this, void 0, void 0, function* () {
            isConnectedRef.current = false;
            // TODO: Maybe reset address to undefined
        }) }));
    // Handle changes of address/network in "realtime"
    react_1.default.useEffect(() => {
        let timeoutId = null;
        const freighterCheckIntervalMs = 200;
        function checkForWalletChanges() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                // Returns if not installed / not active / not connected (TODO: currently always isConnected=true)
                if (!mySorobanContext.activeWallet || !mySorobanContext.activeWallet.isConnected() || !isConnectedRef.current || !mySorobanContext.activeChain)
                    return;
                let hasNoticedWalletUpdate = false;
                try {
                    let chain = networkToActiveChain(yield ((_a = mySorobanContext.activeWallet) === null || _a === void 0 ? void 0 : _a.getNetworkDetails()), chains);
                    let address = yield ((_b = mySorobanContext.activeWallet) === null || _b === void 0 ? void 0 : _b.getPublicKey());
                    if (mySorobanContext.address !== address) {
                        console.log("SorobanReactProvider: address changed from:", mySorobanContext.address, " to: ", address);
                        hasNoticedWalletUpdate = true;
                        console.log("SorobanReactProvider: reconnecting");
                        mySorobanContext.connect();
                    }
                    else if (mySorobanContext.activeChain.networkPassphrase != chain.networkPassphrase) {
                        console.log("SorobanReactProvider: networkPassphrase changed from: ", mySorobanContext.activeChain.networkPassphrase, " to: ", chain.networkPassphrase);
                        hasNoticedWalletUpdate = true;
                        console.log("SorobanReactProvider: reconnecting");
                        mySorobanContext.connect();
                    }
                }
                catch (error) {
                    console.error("SorobanReactProvider: error: ", error);
                }
                finally {
                    if (!hasNoticedWalletUpdate)
                        timeoutId = setTimeout(checkForWalletChanges, freighterCheckIntervalMs);
                }
            });
        }
        checkForWalletChanges();
        return () => {
            if (timeoutId != null)
                clearTimeout(timeoutId);
        };
    }, [mySorobanContext]);
    react_1.default.useEffect(() => {
        console.log("Something changing... in SorobanReactProvider.tsx");
        if (mySorobanContext.address)
            return;
        if (!mySorobanContext.activeWallet)
            return;
        if (mySorobanContext.autoconnect || mySorobanContext.activeWallet.isConnected()) {
            mySorobanContext.connect();
        }
    }, [mySorobanContext.address, mySorobanContext.activeWallet, mySorobanContext.autoconnect]);
    return (react_1.default.createElement(_1.SorobanContext.Provider, { value: mySorobanContext }, children));
}
exports.SorobanReactProvider = SorobanReactProvider;
